import { compose, prop } from 'ramda';
import hasMin from './hasMin';

export default (function (len) {
  return compose(hasMin(len), prop('length'));
});